module.exports = __webpack_public_path__ + "img/2_197.a87461f1.png";